import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { type BillingInvoice } from '../types';

interface TableActionsProps {
  invoice: BillingInvoice;
  onDownload: (invoice: BillingInvoice) => void;
  isPending: boolean;
}

export const TableActions = ({
  invoice,
  onDownload,
  isPending,
}: TableActionsProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return (
    <Button
      variant="terciary"
      icon="leading"
      className="w-full"
      isLoading={isPending}
      onClick={event => {
        event.stopPropagation();
        onDownload(invoice);
      }}
    >
      <FileText className="size-5" />
      {t('BillingPage.viewDocument.cta')}
    </Button>
  );
};
